import axios from 'axios';

export default {
	async createRole(context) {
		let roleData = JSON.stringify(context.getters.getRoleData);
		// let roleData = JSON.stringify({ role: 'hello' });

		const params = new URLSearchParams();
		params.append('roleData', roleData);

		return axios
			.post('/api/roles/createRole', params, {
				headers: {
					'content-type': 'application/x-www-form-urlencoded',
				},
			})
			.then((response) => {
				console.log('SUCCESS!!', response);
				context.dispatch('clearRoleData');
			})
			.catch((err) => {
				console.log('FAILURE!!', err.response.data.message);
				this.errorMessage = err.response.data.message;
			});
	},

	async updateRole(context) {
		let roleData = JSON.stringify(context.getters.getRoleData);
		// let roleData = JSON.stringify({ role: 'hello' });

		const params = new URLSearchParams();
		params.append('roleData', roleData);

		return axios
			.post(`/api/roles/updateRole/${context.getters.getRoleSlug}`, params, {
				headers: {
					'content-type': 'application/x-www-form-urlencoded',
				},
			})
			.then((response) => {
				context.commit('setRoleData', response.data.data);
				return response.data;
			})
			.catch((err) => {
				return err.response.data;
			});
	},

	clearRoleData(context) {
		context.commit('clearRoleData');
	},

	async getAllRoles() {
		const response = await axios
			.get('/api/roles/getAllRoles')
			.then((response) => {
				return response.data;
			})
			.catch((err) => {
				console.log('FAILURE!!', err.response.data.message);
				this.errorMessage = err.response.data.message;
			});

		return response;
	},

	async fetchRoleData(context, slug) {
		return await axios
			.get(`/api/roles/findRole/${slug}`)
			.then(async (response) => {
				// Commits the role's data to the store
				context.commit('setRoleData', response.data);
			})
			.catch((err) => console.log(err.response));
	},
};
